import { useContext } from 'react'

import Link from '@atoms/Link'
import MicrocmsImage from '@atoms/MicrocmsImage'
import LanguageSwitch from '@molecules/LanguageSwitch'
import SnsIcon from '@icons/Sns'
import SaveIcon from '@icons/Save'
import HistoryIcon from '@icons/History'
import UserIcon from '@icons/User'
import { useTranslation } from '@models/Translation'
import { StoreContext } from '@models/Store'
import { Category, useAllArticles } from '@models/Article'

import * as style from './style.module.sass'
import artisanImage from './assets/artisan.webp'
import Modal from '../molecules/Modal'

const Menu = () => {
  const { entity, ui, action } = useContext(StoreContext)
  const { showMenu } = ui
  const { setShowMenu, setShowContactModal } = action
  const { t, locale } = useTranslation()

  const articles = useAllArticles()
  const categories: Category[] = [
    'business',
    'research',
    'philosophy',
    'culture',
    'beauty',
    'info',
  ]
  const specialCategories: Category[] = [
    'features',
    'series',
    'projects',
    'events',
  ]
  const artisanArticle = articles.find(article => article.isArtisan)

  return (
    <div className={style.modalCover}>
      <Modal
        type="overlay-empty"
        show={showMenu}
        outsideClick={() => setShowMenu(false)}
      >
        <div
          className={style.main}
          data-show-banner={ui.banner !== undefined}
          onClick={() => setShowMenu(false)}
        >
          <div className={style.menu}>
            <div data-only="smallTab">
              <div className={style.languageSwitch}>
                <LanguageSwitch design="white" />
              </div>
              <div className={style.links}>
                <Link
                  to={entity.user?.isSignIn ? '/save' : '/signup'}
                  className={style.link}
                >
                  <UserIcon />
                  <span>
                    {entity.user?.isSignIn
                      ? t('mypage.mypage')
                      : `${t('mypage.registration')} / ${t('mypage.login')}`}
                  </span>
                </Link>
                <Link to="/save" className={style.link}>
                  <SaveIcon />
                  {t('mypage.save')}
                </Link>
                <Link to="/history" className={style.link}>
                  <HistoryIcon />
                  {t('mypage.history')}
                </Link>
              </div>
            </div>
            <div className={style.categories}>
              <div className={style.label}>CATEGORIES</div>
              <div className={style.list}>
                {categories.map(category => {
                  const article = articles.find(
                    article => article.data.category === category,
                  )

                  return (
                    <Link
                      className={style.item}
                      key={category}
                      to={`/${category}`}
                    >
                      {article && (
                        <MicrocmsImage
                          image={article.thumbnail}
                          alt={category}
                          type="thumbnail"
                          disableAspectRatio
                        />
                      )}
                      {category.toUpperCase()}
                    </Link>
                  )
                })}
              </div>
            </div>
            <div className={style.special}>
              <div className={style.label}>SPECIAL CONTENT</div>
              <div className={style.list}>
                {specialCategories.map(category => {
                  const article = articles.find(
                    article => article.data.category === category,
                  )

                  return (
                    <Link
                      className={style.item}
                      key={category}
                      to={`/${category}`}
                    >
                      {article && (
                        <MicrocmsImage
                          image={article.thumbnail}
                          alt={category}
                          type="thumbnail"
                          disableAspectRatio
                        />
                      )}
                      {category.toUpperCase()}
                    </Link>
                  )
                })}
                <Link className={style.item} to="/artisan">
                  {artisanArticle && (
                    <MicrocmsImage
                      image={artisanArticle.thumbnail}
                      alt={artisanArticle.title}
                      type="thumbnail"
                      disableAspectRatio
                    />
                  )}
                  ARTISAN
                </Link>
                <Link className={style.item} to="/about">
                  <img src={artisanImage} alt="About us" />
                  ABOUT US
                </Link>
              </div>
            </div>

            <div className={style.bottomMenu}>
              <nav className={style.othersMenu}>
                <Link to="/privacy">
                  <h3>PRIVACY POLICY</h3>
                </Link>
                <Link to="/terms">
                  <h3>{locale === 'ja' ? '利用規約' : 'TERMS'}</h3>
                </Link>
                <Link to="/faq">
                  <h3>FAQ</h3>
                </Link>
                <button onClick={() => setShowContactModal(true)}>
                  <h3>{locale === 'ja' ? 'お問い合わせ' : 'CONTACT'}</h3>
                </button>
              </nav>

              <div className={style.sns}>
                <div className={style.label}>Follow Us</div>
                <nav className={style.icons}>
                  <Link
                    to={
                      locale === 'en'
                        ? 'https://twitter.com/zt_ftn_en'
                        : 'https://twitter.com/zt_ftn'
                    }
                    className={style.icon}
                    data-name="x"
                  >
                    <SnsIcon name="x" />
                  </Link>
                  <Link
                    to="https://www.instagram.com/fashiontechnews_official"
                    className={style.icon}
                    data-name="instagram"
                  >
                    <SnsIcon name="instagram" />
                  </Link>
                  <Link
                    to="https://www.linkedin.com/showcase/fashion-tech-news"
                    className={style.icon}
                    data-name="linkedin"
                  >
                    <SnsIcon name="linkedin-skelton" />
                  </Link>
                  <Link
                    to="https://ftn.zozo.com/"
                    className={style.icon}
                    data-name="note"
                  >
                    <SnsIcon name="note" />
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Menu
